import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
export var Portal = function (_a) {
    var children = _a.children, wrapper = _a.wrapper;
    var _b = useState(false), innerHtmlRemoved = _b[0], setInnerHtmlRemoved = _b[1];
    useEffect(function () {
        if (!innerHtmlRemoved) {
            wrapper.innerHTML = "";
            setInnerHtmlRemoved(true);
        }
    }, [innerHtmlRemoved, wrapper]);
    if (!innerHtmlRemoved) {
        return null;
    }
    return ReactDOM.createPortal(children, wrapper);
};
